<div class="sr-info-container">
    <div class="form-header" *ngIf="_commonService.isMobile(); else desktopHeader">
        <button clickable class="btn-close" (click)="closeDialog()">
          <img
            src="./assets/images/left-arrow-active.svg"
            alt="arrow"
          />
        </button>
        <h2 class="form-title">{{ data.requestTypeDesc }}</h2>
    </div>
    <ng-template #desktopHeader>
        <div class="form-header">
            <button clickable class="btn-close">
                <img
                  src="./assets/images/cross_green.svg"
                  alt="arrow" (click)="closeDialog()"
                />
            </button>
        </div>
    </ng-template>
    <mat-tab-group>
        <mat-tab label="Status">
            <div class="service-request-info" >
                <div class="service-request-details">
                    <div class="service-request-detail-row">
                        <div class="row-left">
                            <span class="service-request-desc">{{ data.requestTypeDesc }}</span>
                            <span class="service-request-number">{{'SERVICEREQUESTLANDING.ref'| translate}} {{ data.requestReference}}</span>
                        </div>
                        <div class="row-right">
                            <span class="date">{{ data.requestDate | date :'dd/MM/yyyy' }}</span>
                            <span [ngClass]="data.customerStatus?.toLowerCase()" class="service-request-status">
                                {{ data.customerStatus}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="stage-grid">
                <app-service-request-stages-display-grid ></app-service-request-stages-display-grid>
            </div>
        </mat-tab>
        <mat-tab label="Request">
            <div class="container-ref">
                <ng-template containerRef></ng-template>
            </div>
        </mat-tab>
    </mat-tab-group>
    
</div>